import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { getResult } from "@/lib/api";
import { ResultView } from "@/pages/Assessment";
import { Section } from "@/components/Primitives";

export default function AssessmentResult() {
  const { submissionId } = useParams();
  const navigate = useNavigate();
  const [result, setResult] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    setResult(null);
    setNotFound(false);
    getResult(submissionId)
      .then(setResult)
      .catch(() => setNotFound(true));
  }, [submissionId]);

  if (notFound) {
    return (
      <Section className="pt-24 pb-24 text-center" data-testid="result-not-found">
        <h1 className="font-playfair text-3xl text-stone-900">Result not found</h1>
        <p className="text-stone-500 mt-3">This results link may be incorrect or no longer available.</p>
        <Link to="/assessments" className="text-[#1F3D2E] font-semibold mt-4 inline-block" data-testid="result-back-to-hub">
          Back to all assessments
        </Link>
      </Section>
    );
  }

  if (!result) {
    return (
      <Section className="pt-24 pb-24">
        <p className="text-stone-500" data-testid="result-loading">Loading your results…</p>
      </Section>
    );
  }

  return <ResultView result={result} onRetake={() => navigate(`/assessments/${result.assessment_id}`)} />;
}
